<div
  *ngIf="app.hasError"
  class="error-notification top-bar"
  style="cursor: pointer"
  [ngClass]="{'error-notification-modal': app.hasError}"
>
  <div class="container">
    <div class="p-1">
      <div class="col-md-2 pull-left">
        <i class="fa-solid fa-ban banIcon"></i>
      </div>
      <div class="col-md-10 pull-right">
        <div class="col-md-12 text-danger text-uppercase">
          {{app.text.app.error}}
          <div class="close-btn pull-right" (click)="app.hasError= false">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="col-md-12">
          {{ app.errorText }}
        </div>
     
      </div>
    </div>
  </div>
</div>
<ng-template
  #content
  let-modal
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
<!-- Current view is request password -->
  <div class="m-1 p-1" *ngIf="!routeParams.token && !app.state.passwordChangeRequired">
    <button
      class="btn pull-right"
      (click)="app.routing.navigateLogin(); modal.dismiss('CANCEL')"
    >
      <i class="fa fa-times"></i>
    </button>
    <div class="m-2 p-2 text-center">
      <i class="fa-regular fa-sign-post resetPasswordIcon"></i>
      <div class="forgotPasswordText">
        {{ app.text.resetPassword.forgotPassword }}
      </div>
      <div class="enterEmailText">{{ app.text.resetPassword.enterEmail }}</div>
    </div>
    <div class="controls m-1">
      <button
        *ngIf="requiredFields.length < 1"
        class="btn"
        [title]="app.text.user.save"
      >
        <i class="fa fa-check"></i>
      </button>
    </div>
    <div class="resetBody m-5">
      <div class="m-1">
        <form
          class="resetForm"
          [formGroup]="resetForm"
          (ngSubmit)="requestChangePass()"
        >
          <label for="emailInput" class="form-label emailLabel">{{
            app.field.getLabel(app.fieldId.user.email)
          }}</label>
          <div class="input-group mb-3">
            <input
              type="email"
              aria-label="Email"
              id="emailInput"
              class="form-control emailInput"
              formControlName="email"
            />
          </div>
        </form>
        <div class="controls">
          <button
            class="btn sendEmailBtn"
            (click)="requestChangePass()"
            [disabled]="!resetForm.valid"
          >
            {{ app.text.resetPassword.sendEmail }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Current view after request password -->
  <div class="m-1 p-1" *ngIf="routeParams.token && tokenValid || app.state.passwordChangeRequired">
    <button
      class="btn pull-right"
      (click)="app.routing.navigateLogin(); modal.dismiss('CANCEL')"
    >
      <i class="fa fa-times"></i>
    </button>
    <div class="m-2 p-2 text-center">
      <i class="fa-solid fa-envelopes-bulk resetPasswordIcon"></i>
      <div class="forgotPasswordText">
        {{ app.text.resetPassword.resetPassword }}
      </div>
      <div class="enterEmailText">
        {{ app.text.resetPassword.insertPassword }}
      </div>
    </div>
    <div class="resetBody m-5">
      <div class="m-1">
        <form
          class="passwordForm"
          [formGroup]="passwordForm"
          (ngSubmit)="changePassword()"
        >
          <label for="passwordInput" class="form-label emailLabel">{{
            app.field.getLabel(app.fieldId.user.password)
          }}</label>
          <div class="input-group mb-3">
            <input
              type="password"
              aria-label="Last name"
              id="passwordInput"
              class="form-control emailInput"
              formControlName="password"
            />
          </div>

          <div>
            <div *ngIf="passwordForm.controls.password.errors" class="passwordErrors">
              <ul>
                <li>

                  <small>{{app.text.resetPassword.passLength}} {{app.auth.passwordLength}} {{app.text.resetPassword.char}}</small>
                </li>
                <li>

                  <small>{{app.text.resetPassword.upperCase}}</small>
                </li>
                <li>

                  <small>{{app.text.resetPassword.digit}}</small>
                </li>
                <li>
                  <small>{{app.text.resetPassword.specialChar}}</small>

                </li>
              </ul>
          </div>
          </div>
          <label for="retypePassword" class="form-label emailLabel">{{
            app.field.getLabel(app.fieldId.user.retypePassword)
          }}</label>
          <div class="input-group mb-3">
            <input
              type="password"
              aria-label="Last name"
              id="retypePassword"
              class="form-control emailInput"
              formControlName="retypePassword"
            />
          </div>
          <div *ngIf="passwordForm.controls.retypePassword.errors" class="passwordErrors">
            <small
              
              *ngIf="passwordForm.controls.retypePassword.errors.mustMatch"
              >{{ app.text.resetPassword.mustMatch }}</small
            >
          </div>
        </form>
      </div>
      <div class="controls mt-2">
        <button
          class="btn sendEmailBtn"
          (click)="changePassword()"
          [disabled]="!passwordForm.valid"
        >
          {{ app.text.resetPassword.save }}
        </button>
      </div>
    </div>
  </div>
  <!-- Current view if the token has expired -->
  <div class="m-1 p-1" *ngIf="routeParams.token && !tokenValid">
    <button
      class="btn pull-right"
      (click)="app.routing.navigateLogin(); modal.dismiss('CANCEL')"
      [ngbTooltip]="app.text.user.discard"
    >
      <i class="fa fa-times"></i>
    </button>
    <div class="m-5 p-2 text-center">
      <i class="fa-regular fa-face-confused resetPasswordIcon"></i>
      <div class="forgotPasswordText">
        {{ app.text.resetPassword.linkExpired }}
      </div>
      <div class="enterEmailText">{{ app.text.resetPassword.redirect }}</div>
    </div>
  </div>
</ng-template>
